import { type PropsWithChildren } from 'react';
import { cn } from '@bedrock/ui/utils';

type PageBlockProps = Readonly<PropsWithChildren<{ className?: string }>>;

export const PageBlock = ({ children, className }: PageBlockProps) => {
  return (
    <div
      className={cn(
        className,
        'py-5xl mx-auto overflow-x-clip px-[var(--container-padding-mobile)] md:px-[var(--container-padding-tablet)] 2xl:px-[var(--container-padding-desktop)]',
      )}
    >
      {children}
    </div>
  );
};
